import axios from 'axios';

type TCountryCode = 'GB' | 'GBR' | 'AE';

interface ICountryCodeResponse {
  ip: string;
  city: string;
  region: string;
  country: TCountryCode;
  loc: string;
  org: string;
  timezone: string;
  readme: string;
}

interface IBigDataCountryCodeResponse {
  countryName: string;
  countryCode: TCountryCode;
}

export async function getCountryCode(): Promise<TCountryCode | undefined> {
  const { data } = await axios.get<ICountryCodeResponse>(
    'https://ipinfo.io/json',
  );

  return data?.country;
}

// https://www.bigdatacloud.com/free-api/free-reverse-geocode-to-city-api
export async function getCountryCodeViaBigData(): Promise<TCountryCode | undefined> {
  const { data } = await axios.get<IBigDataCountryCodeResponse>(
    'https://us1.api-bdc.net/data/reverse-geocode-client',
  );

  return data?.countryCode;
}

export function isUkCountry(countryCode?: TCountryCode): boolean {
  return countryCode === 'GB' || countryCode === 'GBR';
}
